import * as f from './_cmFTH';

import * as hf from './_hf';
import * as ht from './_ht';

export const load_40rLsAsync = async () => {
  const _cdn = f.vdd(false, false);
  const _ls = await f.loadLsAsync({
    tgt: '_40rs',
    cdn: _cdn,
    fld: '_key as key, _pfx as pfx, *', // 履歴対象外のため key
  });
  return _ls;
};

export const load_40rAzAsync = async (pz?: {
  _31r_fst?: ht.n,
  _10r_key?: ht.n,
}) => {
  let _cdn = f.vdd(false, false);
  if (pz?._31r_fst && pz?._10r_key) _cdn += `
    AND _key IN (
      SELECT
        _411_40r1k
      FROM
        _411s
      WHERE
        ${f.vdd(false)}
        AND _411_31r1f = ${pz?._31r_fst}
        AND _411_41r1k IN (
          SELECT
            _key
          FROM
            _41rs
          WHERE
            ${f.vdd()}
            AND _fst IN (
              SELECT
                _421_41r1f
              FROM
                _421s
              WHERE
                ${f.vdd(false)}
                AND _421_42r1k IN (
                  SELECT
                    _key
                  FROM
                    _42rs
                  WHERE
                    ${f.vdd()}
                    AND _42r_10r1k = ${pz?._10r_key}
                )
            )
        )
    )
  `;
  const _ls = await f.loadLsAsync({
    tgt: '_40rs',
    cdn: _cdn,
    fld: '_key as key, _pfx as pfx, *', // 履歴対象外のため key
  });
//  return hf.cvtLsToDz(_ls, ( _dz: ht.dz ) => String(_dz._key))
  return hf.cvtLsToDz(_ls, ( _dz: ht.dz ) => String(_dz._icn))
};
